import { SUPPORTED_TARGETS } from '../../utils/home/constants';
import getSafe from '../../utils/getSafe';
import {
  TRACK_TAPPED_SEARCH_BAR,
  TRACK_TYPED_IN_SEARCH_BAR,
  TRACK_TAPPED_SEARCH_RESULT,
  TRACK_VIEWED_SEARCH_DROP_DOWN,
} from './types';

const getTargetData = (target) => {
  if (target.typeName === SUPPORTED_TARGETS.PARAMS) {
    return {
      id: null,
      type: 'Params',
      value: target.title,
    };
  }
  if (target.typeName === SUPPORTED_TARGETS.RESTAURANT) {
    return {
      id: getSafe(() => target.restaurant.id),
      type: 'Restaurant',
      value: getSafe(() => target.title.name),
    };
  }
  if (target.typeName === SUPPORTED_TARGETS.MENU_ITEM) {
    return {
      id: getSafe(() => target.menuItem.id),
      type: 'Dish',
      value: getSafe(() => target.title.name),
    };
  }
  return {};
};

export function trackTappedSearchBar() {
  return (dispatch) =>
    dispatch({
      type: TRACK_TAPPED_SEARCH_BAR,
      payload: {
        name: 'Tapped Search Bar',
        properties: {},
      },
    });
}

export function trackTypedInSearchBar(searchTerm) {
  return (dispatch) =>
    dispatch({
      type: TRACK_TYPED_IN_SEARCH_BAR,
      payload: {
        name: 'Typed In Search Bar',
        properties: {
          'Search term': searchTerm,
        },
      },
    });
}

export function trackTappedSearchResult(searchTerm, target) {
  const { id, value, type } = getTargetData(target);
  return (dispatch) =>
    dispatch({
      type: TRACK_TAPPED_SEARCH_RESULT,
      payload: {
        name: 'Tapped Search Result',
        properties: {
          'Search term': searchTerm,
          'Target type': type,
          'Target ID': id,
          'Target value': value,
        },
      },
    });
}

export function trackViewedSearchDropDown(results) {
  return (dispatch) =>
    dispatch({
      type: TRACK_VIEWED_SEARCH_DROP_DOWN,
      payload: {
        name: 'Viewed Search Drop Down',
        properties: {
          'Results array': results,
        },
      },
    });
}
